<template>
  <div v-if="detail">
    <card style="margin-top: 10px">
      <description-list class="info-body" type="large">
        <description-list-item term="订单编号">
          {{ detail.orderNo }}
        </description-list-item>
        <description-list-item term="下单时间">
          {{ detail.createTime }}
        </description-list-item>
        <description-list-item term="客户主体">
          <span v-if="detail.buyerType == 1">个人</span>
          <span v-else>公司</span>
        </description-list-item>
        <description-list-item term="订购人">
          {{ detail.contactName }}
        </description-list-item>
        <description-list-item term="联系电话">
          {{ detail.contactPhone }}
        </description-list-item>
        <description-list-item term="订单状态">
          <span class="order-status order-status-wait">
            {{ statusEnum[detail.status] }}
          </span>
        </description-list-item>
        <description-list-item term="订单类型">
          <span class="order-status order-status-wait">
            <span v-if="detail.type == 1">现售</span>
            <span v-else>预售</span>
          </span>
        </description-list-item>
        <description-list-item term="已付金额">
          {{ detail.paymentAmount }}
        </description-list-item>
        <description-list-item term="可用金额">
          {{ detail.remainAmount }}
        </description-list-item>
        <description-list-item term="预订油价" v-if="detail.type == 2">
          {{ detail.discountPrice }}
        </description-list-item>
        <description-list-item term="预订加油量" v-if="detail.type == 2">
          {{ detail.quantity
          }}<span
            >(已加{{ detail.usedQuantity + detail.unitName }},剩余{{
              detail.remainQuantity + detail.unitName
            }})</span
          >
        </description-list-item>
        <description-list-item term="溯源" v-if="detail.origin">
          <span v-if="detail.origin == 1">默认</span>
          <span v-if="detail.origin == 2">溯源</span>
        </description-list-item>
        <description-list-item
          term="订单备注"
          contentStyle="word-break: break-all;"
          >{{ detail.remark }}
        </description-list-item>
        <card
          style="margin-top: 10px;"
          v-for="goods in detail.orderItems"
          :key="goods.id"
        >
          <div class="oil-list-item">
            <div class="oil-logo">
              <img :src="goods.image" alt="" />
            </div>
            <div class="oil-detail">
              <div class="oil-detail-info">
                <div class="flex-between-center">
                  <div class="oil-detail-title" v-html="goods.name"></div>
                  <span class="oil-detail-price "
                    >￥{{ goods.discountPrice }}</span
                  >
                </div>
                <div class="flex-between-center">
                  <div class="oil-detail-spec gray-12">
                    规格：{{ goods.volume }}
                  </div>
                  <span class="oil-detail-quantity gray-12"
                    >x{{ goods.quantity }}</span
                  >
                </div>
              </div>
              <div class="oil-detail-extra">
                <div class="oil-detail-total">
                  <span class="oil-detail-total-prefix">合计: </span>￥<span
                    style="font-size: 16px;font-weight: bold"
                    >{{ goods.discountTotalPrice }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </card>
        <div class="accountBox" v-if="detail.status >= 3 && userType == 'user'">
          <div class="accountWrapper">
            <div class="accountTitle">收款方账户名</div>
            <div class="accountLine">
              <span class="accountName">{{ detail.payeeAccountName }}</span>
            </div>
          </div>
          <div class="accountWrapper">
            <div class="accountTitle">收款方账户</div>
            <div class="accountLine">
              <span class="accountName">{{ detail.payeeAccountNo }}</span>
            </div>
          </div>
          <div class="accountWrapper">
            <div class="accountTitle">开户网点</div>
            <div class="accountLine">
              <span class="accountName"> {{ detail.payeeAccountBank }}</span>
            </div>
          </div>
        </div>
      </description-list>
    </card>

    <x-button
      class="addOil"
      v-if="addShow && userType == 'admin' && detail.remainQuantity > 0"
      mini
      @click.native="addOrder"
      >新增加油信息</x-button
    >
    <!--    <tab style="margin-top: 10px;" v-if="detail.details.length>0">-->
    <!--      <tab-item :key="item.id" v-for="(item,index) in detail.details" @on-item-click="onItemClick(index)">订购信息{{index+1}}</tab-item>-->
    <!--    </tab>-->
    <div class="orderTitleWrapper" v-if="detail.details.length > 0">
      <div
        class="orderTitle"
        :class="titleIndex == index ? 'orderTitleActive' : ''"
        :key="item.id"
        v-for="(item, index) in detail.details"
        @click="onItemClick(index)"
      >
        订购信息{{ index + 1 }}
      </div>
    </div>
    <card v-if="details">
      <description-list type="large" class="info-body">
        <description-list-item term="用油时间">{{
          details.useTime.split(" ")[0]
        }}</description-list-item>
        <description-list-item term="用油地址">{{
          details.address
        }}</description-list-item>
        <description-list-item term="运输方式">
          <span v-if="details.shipType == 2">船发</span>
          <span v-if="details.shipType == 3">车发</span>
        </description-list-item>
        <description-list-item term="运输编号">{{
          details.shipCode
        }}</description-list-item>
        <description-list-item term="渔船编号" v-if="details.clientShipCode">
          {{ details.clientShipCode }}
        </description-list-item>
        <!--        <description-list-item term="付款人">{{-->
        <!--          details.payerName-->
        <!--        }}</description-list-item>-->
        <description-list-item term="付款方式">
          <span v-if="details.paymentMethod == 1">线上</span>
          <span v-else>线下</span>
        </description-list-item>
        <!--        <description-list-item term="付款银行卡">{{-->
        <!--          details.bankNo-->
        <!--        }}</description-list-item>-->
        <description-list-item
          term="备注"
          contentStyle="word-break: break-all;"
          >{{ details.remark }}</description-list-item
        >
      </description-list>
    </card>
    <card style="margin-top: 10px;" v-if="details">
      <div class="oil-list-item">
        <div class="oil-logo">
          <img :src="details.image" alt="" />
        </div>
        <div class="oil-detail">
          <div class="oil-detail-info">
            <div class="flex-between-center">
              <div class="oil-detail-title">{{ details.name }}</div>
              <span class="oil-detail-price "
                >￥{{ details.discountPrice }}</span
              >
            </div>
            <div class="flex-between-center">
              <div class="oil-detail-spec gray-12">
                规格：{{ details.volume }}
              </div>
              <span class="oil-detail-quantity gray-12"
                >x{{ details.quantity }}</span
              >
            </div>
          </div>
          <div class="oil-detail-extra">
            <div class="oil-detail-total">
              <span class="oil-detail-total-prefix">合计: </span>￥<span
                style="font-size: 16px;font-weight: bold"
              >
                {{
                  (
                    (details.discountPrice * details.quantity * 10) /
                    10
                  ).toFixed(2)
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </card>
    <card title="业务员信息" style="margin-top: 10px;" v-if="details">
      <description-list type="large" class="info-body">
        <description-list-item term="业务员">{{
          details.userName
        }}</description-list-item>
        <description-list-item term="联系电话">{{
          details.userPhone
        }}</description-list-item>
        <description-list-item term="车牌号" v-if="details.carCode">
          {{ details.carCode }}
        </description-list-item>
      </description-list>
    </card>
    <CardPreviewer
      style="margin-top: 10px;"
      title="凭证信息"
      v-if="details"
      :images="images"
    ></CardPreviewer>
    <div class="empty"></div>
    <slot></slot>
    <div class="backIcon" @click="back">
      <Icon slot="icon" style="font-size: 24px;" type="iconkaobei" />
    </div>
    <!-- 预约加油 -->
    <div v-if="isZlb && detail.status === 3" class="appoint-button">
      <x-button class="appoint" mini @click.native="appointOilShow = true"
        >预约加油</x-button
      >
      <x-button class="appoint" mini @click.native="linkToHistory"
        >预约记录</x-button
      >
    </div>
    <!-- 加油表单 -->
    <x-dialog class="dialog-appoint" v-model="appointOilShow" hide-on-blur>
      <div class="oilMain vux-1px-b">
        <x-input
          :title="'加油数量/' + detail.orderItems[0].volume"
          placeholder="请输入加油数量"
          type="number"
          align="left"
          text-align="right"
          :show-clear="false"
          v-model="appointForm.quantity"
          placeholder-align="right"
        ></x-input>
      </div>
      <div class="oilMain vux-1px-b">
        <datetime
          placeholder="请选择时间"
          format="YYYY-MM-DD HH:mm"
          v-model="appointForm.appointTime"
          title="预约时间"
        ></datetime>
      </div>
      <x-button class="appoint" mini @click.native="submitAppoint"
        >预约</x-button
      >
    </x-dialog>
  </div>
</template>

<script>
import {
  DescriptionList,
  DescriptionListItem
} from "@/components/DescriptionList";
import CardPreviewer from "@/components/Card/CardPreviewer";
import { supplyOilAppoint } from "@/api/oilAppoint";

import { statusEnum } from "@/views/order/enum";
import { getType, getZlb } from "../../utils/auth";
import { dateFormat } from "../../utils/date2";
export default {
  components: { DescriptionList, DescriptionListItem, CardPreviewer },
  props: ['detail'],
  data() {
    return {
      isZlb: false,
      appointOilShow: false,
      appointForm: {
        quantity: "",
        appointTime: ""
      },
      startDate: null,
      endDate: null,
      appointOilNum: "",
      statusEnum,
      details: "",
      addShow: "",
      titleIndex: 0,
      userType: ""
    };
  },
  watch: {
    detail(e) {
      if (e && e.details.length > 0) {
        this.details = e.details[0];
      }
      if (e.type == 1) {
        if (e.status == 3 && e.details.length < 1) {
          this.addShow = true;
        } else {
          this.addShow = false;
        }
      } else {
        if (this.detail.status == 3) {
          this.addShow = true;
        } else {
          this.addShow = false;
        }
      }
    }
  },
  created() {
    const date = new Date();
    this.appointForm.appointTime = dateFormat(date, "yyyy-MM-dd hh:mm");
    this.userType = getType();
    this.isZlb = getZlb();
    if (this.detail && this.detail.details.length > 0) {
      this.details = this.detail.details[0];
    }
    if (this.detail) {
      if (this.detail.type == 1) {
        if (this.detail.status == 3 && this.detail.details.length < 1) {
          this.addShow = true;
        } else {
          this.addShow = false;
        }
      } else {
        if (this.detail.status == 3) {
          this.addShow = true;
        } else {
          this.addShow = false;
        }
      }
    }
  },
  computed: {
    images() {
      if (this.details && this.details.confirmVoucher) {
        if (this.details.confirmVoucher.indexOf(",") > 0) {
          const a = this.details.confirmVoucher.split(",");
          return a;
        } else {
          return [this.details.confirmVoucher];
        }
      }
      return [];
    }
  },
  methods: {
    back() {
      if (getType() == "user") {
        this.$router.push("/order");
      } else {
        this.$router.push("/salesman/index");
      }
    },
    addOrder() {
      this.$router.push({ name: "addOrder" });
    },
    onItemClick(index) {
      this.details = this.detail.details[index];
      this.titleIndex = index;
    },
    // 提交预约
    submitAppoint() {
      const { id } = this.detail;
      if (this.appointForm.quantity) {
        this.$vux.loading.show({
          transition: "",
          text: "提交中"
        });
        this.appointForm.appointTime = this.appointForm.appointTime + ":00";
        supplyOilAppoint({ ...this.appointForm, id })
          .then(() => {
            this.$vux.loading.hide();
            this.$showError("预约成功");
            this.appointOilShow = false;
          })
          .catch(error => {
            this.$vux.loading.hide();
            this.appointOilShow = false;
            this.$showError(error, "warn");
          });
      } else {
        this.$vux.toast.show({
          text: "请输入数量",
          type: "warn"
        });
      }
    },
    // 前往预约记录历史
    linkToHistory() {
      const { id } = this.detail;
      this.$router.push({
        path: `/order/${id}/oilAppointHistory`
      });
    }
  }
};
</script>

<style lang="less" scoped>
.backIcon {
  position: fixed;
  bottom: 100px;
  right: 50px;
  width: 60px;
  height: 60px;
  z-index: 10;
  border: 1px solid rgb(119, 119, 119);
  border-radius: 50px;
  text-align: center;
  line-height: 60px;
  background: #fff;
}
.orderTitleWrapper {
  margin-top: 10px;
  clear: both;
  background: #fff;
  height: 88px;
  border-bottom: 1px solid #eee;
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  /*display: flex;*/
  &::-webkit-scrollbar {
    display: none;
  }
}
.orderTitle {
  display: inline-block;
  font-size: 14px;
  text-align: center;
  width: 200px;
  height: 88px;
  line-height: 88px;
  overflow: hidden;
}
.orderTitleActive {
  color: #0070ff;
}
.addOil {
  color: #039df8;
  border: 1px solid #039df8;
  background: #fff;
  margin-top: 20px;
  margin-left: 20px;
}
.empty {
  height: 90px;
}
.info-body {
  padding: 20px 30px;
}
.order {
  &-status {
    &-wait {
      color: #ff3600;
    }
  }
  &-header {
    display: flex;
  }
}
.oil {
  &-list-item {
    margin-top: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 1);
    /*box-shadow: 0px 3px 7px 0px rgba(186, 210, 234, 0.3);*/
    border-radius: 14px;
    display: flex;
  }
  &-logo {
    flex: none;
    margin-right: 30px;
    img {
      display: block;
      height: 140px;
      width: 140px;
    }
  }
  &-detail {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    &-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 1em;
      color: rgba(17, 17, 17, 1);
    }
    &-spec {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
    &-extra {
      display: flex;
      justify-content: space-between;
      line-height: 1em;
    }
    &-total {
      &-prefix {
        color: #535353;
        font-size: 12px;
      }
      color: #ff3600;
      font-size: 15px;
    }
    &-price {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #525252;
    }
    &-action {
      width: 50px;
      height: 50px;
      background: rgba(246, 246, 246, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
    }
  }
}
.accountBox {
  overflow: hidden;
  clear: both;
  display: block;
  margin: 20px 0;
  padding: 20px 20px;
  background: -webkit-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: -o-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: -moz-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: linear-gradient(121deg, #2f92f1, #65c8ff);
  border-radius: 20px;
}

.accountWrapper {
  overflow: hidden;
  text-align: left;
  color: #fff;
  margin: 20px 0;
}

.accountTitle {
  font-size: 12px;
  line-height: 40px;
}

.accountLine {
  line-height: 40px;
}

.accountName {
  float: left;
  display: block;
  font-size: 14px;
}
.oil-hetong {
  color: #777777;
  padding: 0 30px;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
}
.appoint-button {
  display: flex;
  align-items: center;
  padding-bottom: 50px;
  margin-top: -50px;
}
.appoint {
  color: #039df8;
  border: 1px solid #039df8;
  background: #fff;
}
.weui-btn + .weui-btn {
  margin-top: 0;
}
.oilMain {
  background: #fff;
  font-size: 14px;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  background: #000;
}
.dateInput {
  width: 100%;
  text-align: right;
}
</style>
<style>
.dialog-appoint .weui-dialog {
  top: 25% !important;
  padding: 30px 0;
}
</style>
